import React, { useState, useCallback } from "react";
import ShopSidebar from "./ShopSidebar";
import ShopProduct from "./ShopProduct";

const ShopSection = () => {


  const [grid, setGrid] = useState(false);
  const [active, setActive] = useState(false);

  const [filters, setFilters] = useState({
    price: [0, 99999],
    rating: "",
    color: "",
    brand: "",
    category: "", // keep your structure unchanged
  });

  const sidebarController = () => setActive(!active);

  const handleFilterChange = useCallback((newFilters) => {
    setFilters((prev) => ({ ...prev, ...newFilters }));
  }, []);

  return (
    <section className="shop py-80">
      <div
        className={`side-overlay ${active && "show"}`}
        onClick={sidebarController}
      ></div>

      <div className="container container-lg">
        <div className="row">

          <ShopSidebar
            active={active}
            sidebarController={sidebarController}
            onFilter={handleFilterChange}
          />

          <ShopProduct
            grid={grid}
            setGrid={setGrid}
            sidebarController={sidebarController}
            filters={filters}
          />

        </div>
      </div>
    </section>
  );
};

export default ShopSection;
